import { validateAndDecodeToken } from '@sharedHelpers/validateAndDecodeToken';

export const wrapperFetchCheckedValidateToken = async callback => {
  const isData = validateAndDecodeToken();
  if (isData) {
    return await callback();
  } else {
    throw new Error();
  }
};
